export default "/images/gfforsikring.png?133dc07c4ee27ce6616fc67df18748a0";